import compose from 'utils/composeEnhancer'
import useAnimationObserver from './useAnimationObserver'

export default compose(
  useAnimationObserver
)